/* eslint-disable */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Dropdown from 'rc-dropdown'
import Menu, { MenuItem } from 'rc-menu'
import styled, { createGlobalStyle } from 'styled-components'
import isFunction from 'lodash-es/isFunction'
import 'rc-dropdown/assets/index.css'
import zIndexScale from '../../utils/zIndexScale'
import Icon from '../../components/common/Icon'

const Wrapper = styled.div`
  position: relative;
  text-indent: 10px;
  border-radius: 0px;
  font-size: 14px;
  color: ${({ theme }) => theme.dropdownTextDisplayColor};
  height: 22px;
  line-height: 22px;
  display: inline-block;
  cursor: pointer;
  box-sizing: border-box;
  min-width: 100px;
  z-index: ${() => zIndexScale.dropdown};
  width: ${props => (props.width ? props.width : 'inherit')};
  text-align: left;

  .selectValue {
    display: inline-block;
    vertical-align: top;
  }
  .dropdown {
    display: flex;
    align-items: center;

    &.rc-dropdown-open {
      .triangle {
        transform: translate(0, -50%) rotate(180deg);
      }
    }
    .triangle {
      transform: translate(0, -50%) rotate(0deg);
      transition: transform 0.3s ease-in-out;
    }
  }

  .triangle {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translate(0, -50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${({ theme }) => theme.dropdownSelectItemColor};
  }
`

const GlobalStyle = createGlobalStyle`
  .rc-dropdown{
    max-height: 180px;
    overflow: auto;
    box-shadow: 0px 1px 4px 0px rgba(90,102,124,0.2);
    border-radius:3px;
    z-index: ${zIndexScale.modal} !important;

    ::-webkit-scrollbar {
      width: 6px;
      border-radius: 2px;
      background-color: #DFE2E7;
    }

    ::-webkit-scrollbar-track {
      border-radius: 2px;
      background-color: #fff;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background-color: #848E9C;
    }

    ::-webkit-scrollbar-corner {
      background-color: #848E9C;
    }

    .rc-dropdown-menu {
      margin: 0px;
      border: none;
      box-shadow: 0 0 6px rgba(0,0,0,0.2);
      background: ${({ theme }) => theme.dropdownBg};

      .rc-dropdown-menu-item {
        cursor: pointer;
        color: ${({ theme }) => theme.dropdownSelectItemColor};

        &:hover{
          color:#f0b90b;
          background-color: ${({ theme }) => theme.dropdownSelectBgColor};
        }
      }

      .rc-dropdown-menu-item-selected{
        color:#f0b90b;
        background-color: ${({ theme }) => theme.dropdownSelectBgColor};

        &:after {
          content: '';
        }
      }
    }
  }

  /* make language select always dark theme */
  .rc-dropdown.header-dropdown-overlay {
      .rc-dropdown-menu {
        background: ${({ theme }) => theme.headerDropdownBg};

        .rc-dropdown-menu-item {
          background: ${({ theme }) => theme.headerDropdownBg};
          color: ${({ theme }) => theme.fontColor};

          &:hover{
            color:${({ theme }) => theme.highlight};
            background-color: ${({ theme }) => theme.headerDropdownItemHoverBg};
          }
        }

        .rc-dropdown-menu-item-selected{
          color:${({ theme }) => theme.highlight};
          background-color: ${({ theme }) => theme.headerDropdownItemHoverBg};
        }
      }
  }
`

class Select extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    options: PropTypes.array,
    defaultValue: PropTypes.string,
    overlayClassName: PropTypes.string,
    width: PropTypes.string,
    withSearchBox: PropTypes.bool,
  }

  static defaultProps = {
    options: [{ text: '', value: '' }],
    defaultValue: null,
    onChange: () => {},
    width: '',
    overlayClassName: '',
    withSearchBox: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      value: '',
    }
  }

  _buildDefaultValue = () => {
    let { defaultValue } = this.props
    if (defaultValue) return defaultValue

    const { options } = this.props

    if (options.length === 0) return ''

    return options[0].text
  }

  _onSelect = ({ key }) => {
    const { onChange } = this.props
    this.setState({ value: key })
    onChange && onChange(key)
  }

  _getText = val => {
    const item = this.props.options.filter(i => i.value === val)[0]
    const text = (item && item.text) || 'English'

    return text
  }

  render() {
    const { value } = this.state
    const { options, width, className, overlayClassName } = this.props
    const defaultValue = this._buildDefaultValue()
    const selectedKeys = value ? [value] : [defaultValue]
    const liOpts = options.map(opt => (
      <MenuItem key={opt.value}>{isFunction(opt.render) ? opt.render() : opt.text}</MenuItem>
    ))

    const menu = (
      <Menu onSelect={this._onSelect} defaultSelectedKeys={selectedKeys}>
        {liOpts}
      </Menu>
    )

    return (
      <Wrapper width={width} className={`select ${className ? className : ''}`}>
        <Dropdown
          trigger={['hover']}
          overlay={menu}
          animation="slide-up"
          overlayClassName={overlayClassName}
        >
          <div className="dropdown">
            <Icon type="language-D" />
            <div className="selectValue">{this._getText(value || defaultValue)}</div>
            <i className="triangle" />
          </div>
        </Dropdown>
        <GlobalStyle />
      </Wrapper>
    )
  }
}

export default Select
